import { render } from "./Item1.vue?vue&type=template&id=42a6a0e7"
import script from "./Item1.vue?vue&type=script&lang=js"
export * from "./Item1.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__